const mutations = {

}
export default mutations;


// WEBPACK FOOTER //
// ./src/store/modules/home/mutations/index.js